<template>
    <div class="has-text-centered has-text-primary">
        <i class="fad fa-spinner-third fa-3x fa-spin"></i>
    </div>
</template>

<script>
export default {
    name: "loading",
};
</script>